"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _radio = require("../../../../radio");
var _misc = require("../../../../misc");
var _Icon = _interopRequireDefault(require("../../../../icon/Icon"));
var _helpers = _interopRequireDefault(require("./helpers"));
var _helpers2 = require("../helpers");
var _FormulaValueHeader = _interopRequireDefault(require("./FormulaValueHeader.style"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var FormulaValueHeader = function FormulaValueHeader(_ref) {
  var rule = _ref.rule,
    disabled = _ref.disabled,
    labels = _ref.labels,
    ruleIndex = _ref.ruleIndex,
    ruleChange = _ref.ruleChange,
    actions = _ref.actions,
    setHasChanges = _ref.setHasChanges;
  return /*#__PURE__*/_react["default"].createElement(_FormulaValueHeader["default"], {
    "data-testid": "formula-value-header"
  }, /*#__PURE__*/_react["default"].createElement(_misc.MenuList, {
    position: "top-right",
    disabled: disabled,
    menuItems: (0, _helpers2.menuListItems)({
      labels: labels,
      actions: actions,
      ruleIndex: ruleIndex,
      setHasChanges: setHasChanges
    }),
    ignoreSingleItemLogic: true
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "ion-android-more-vertical"
  })), /*#__PURE__*/_react["default"].createElement(_radio.RadioGroup, {
    className: "share-view-radiogroup",
    disabled: disabled,
    selectedValue: R.path(['complex', 'activeType'], rule),
    options: (0, _helpers2.shareViewOptions)(labels),
    onChange: function onChange(event) {
      return ruleChange('complex', (0, _helpers["default"])(event, rule));
    }
  }));
};
FormulaValueHeader.defaultProps = {
  disabled: false
};
FormulaValueHeader.propTypes = {
  disabled: _propTypes["default"].bool,
  rule: _propTypes["default"].shape({}).isRequired,
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  ruleIndex: _propTypes["default"].number.isRequired,
  ruleChange: _propTypes["default"].func.isRequired,
  actions: _propTypes["default"].shape({
    deleteRuleBlock: _propTypes["default"].func.isRequired
  }).isRequired,
  setHasChanges: _propTypes["default"].func.isRequired
};
var _default = exports["default"] = FormulaValueHeader;